var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":"/de/dashboard"}},[_c('div',{style:(_vm.navbarLogoStyle),attrs:{"id":"logo-navbar"}})])}
var staticRenderFns = []

export { render, staticRenderFns }